import Jump from 'jump.js';
let jump = new Jump();

let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let accessibility = require('../utilities/accessibility');
let Hammer = require('hammerjs');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

// We should only have one instance.
let instance = null;

class ContentNav {

  constructor() {

    if (!instance) {
      instance = this;
    }

    this.$body = $("body");
    this.$nav = $("#js-content-nav");
    this.$mainNav = $(".js-main-nav");
    this.$contentNavLinks;
    this.$closeBtn;
    this.isAnim = false;
    this.$titles;
    this.hasContent = false;

    // Homepage has slightly different markup.
    if (this.$body.hasClass("path-frontpage")) {
      this.pageTitle = "AbilityLab";
      // Using Hardcoded value since "Advancing Human Ability" is a little long.
      // this.pageTitle = document.getElementsByClassName("homepage-header__title")[0].textContent.trim();
      this.$titles = $("h3.homepage__headline, h2.section-title");
    }
    else if (this.$body.hasClass("path-profile")) {
      this.pageTitle = document.getElementsByClassName("profile-header__name")[0].textContent.trim();
      // Drupal has a hidden label that we need to remove here.
      this.pageTitle = this.pageTitle.replace("Display Name", "");

      this.$titles = $("h2.profile-section__title");
    }
    else {
      this.pageTitle = document.getElementsByClassName("page-header__title");
      this.$titles = $("h2.section-title");

      if (this.pageTitle.length) {
        this.pageTitle = this.pageTitle[0].textContent.trim();
      }
    }

    if (this.pageTitle.length && this.$titles.length) {
      this.hasContent = true;
    }

    this.jumpLinkTargetClass = "content-nav-jump-link";

    // An array storing secondary items (footer elements).
    // Refer to the style guide for possible graphics.
    this.footerElements = [
      {
        "title" : "Contact Us",
        "dom"  : $("#footer-top"),
        "graphic" : "hand-gray"
      },
      {
        "title" : "Ability Labs",
        "dom" : $("#footer-middle-wrapper"),
        "graphic" : "helix-gray"
      }
    ]

    return instance;
  }

  buildContentNav() {
    var hash = window.location.hash.substr(1);
    this.$navContent = this.createContentNav();
    this.$nav.append(this.$navContent);
    this.$contentNavLinks = this.$nav.find('a');
    this.$closeBtn = this.$nav.find(".js-content-nav-close");

    accessibility.toggleTabbing(this.$nav, 'open', this.$closeBtn);
    this.$contentNavLinks.on('click.contentNav', (e) => this.handleClick(e));

    if (hash.length > 0) {
      this.setActiveItem(hash);
    }
  }

  handleClick(e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    var id = $target[0].hash.replace("#", "");

    var currTop = $(window).scrollTop();
    var distance;

    if (id == "") {
      distance = -currTop;
    }
    else {
      var targetLoc = $($target[0].hash).offset().top;
      distance = targetLoc - currTop;
    }

    jump.jump(distance, {
      duration: Math.abs(distance) / 2.5
    });

    window.location.hash = id;

    this.setActiveItem(id);
    this.close();
  }

  createContentNav() {
    var contentNav;

    // Header - includes page title and close button.
    contentNav = "<header class='content-nav__header'>";
    contentNav += "<button class='js-content-nav-close'>";
    contentNav += "<span class='show-for-sr'>close</span>";
    contentNav += "</button>";
    contentNav += "<h3>";
    contentNav += "<a href='/' title='back to top'>";
    contentNav += this.pageTitle;
    contentNav += "</a></h3>";
    contentNav += "</header>";

    // Body - two groups of links.
    contentNav += "<div class='content-nav__body'>";
    contentNav += this.createPageLinks();
    contentNav += this.createFooterLinks();

    contentNav += "</div>";

    return contentNav;
  }

  /*
    createPageLinks() loops through the $titles object. It will add anchor links
    to each title on the page, assign an ID to the link. It returns markup for the
    content nav.
  */
  createPageLinks() {
    var markup;

    markup = "<ul class='content-nav__page-links'>";

    $.each(this.$titles, (index, elem) => {
      var $elem = $(elem);
      var linkText = elem.textContent.trim();
      var linkId = linkText.replace("'", "").replace("+", "and").replace(/ /g, "-").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').toLowerCase();

      // The Event Calendar is a special case.
      // It's title has dom in it and it's layout breaks when the link is added in its header.
      // Here we just make sure it has a sensible slug for the content nav.
      if ($elem.parents('.events-calendar').length > 0) {
        linkId = "upcoming-events";
      }

      this.addJumpLinkTarget($elem, linkId);

      if (linkText.length > 1) {
        markup += this.createJumpLink(linkText, linkId);
      }
      else {
        markup += "<li>Blank h2 on page</li>";
      }

    });

    markup += "</ul>";

    return markup;
  }

  /*
    createFooterLinks() generates and returns markup for the jumplinks to the page
      footer.
  */
  createFooterLinks() {
    var markup;

    markup = "<div class='content-nav__footer-links'>";
    markup += "<ul>";

    for (var i in this.footerElements) {
      var linkText = this.footerElements[i].title;
      var linkId = this.footerElements[i].title.replace("+", "and").replace(/ /g, "-").toLowerCase();
      var elem = this.footerElements[i].dom;
      var graphic = this.footerElements[i].graphic;

      this.addJumpLinkTarget(elem, linkId);

      markup += this.createJumpLink(linkText, linkId, graphic);
    }

    markup += "</ul></div>";

    return markup;
  }

  /*
    createJumpLink() takes two arguments, text and id both as strings, to construct
    a link inside an li.
  */
  createJumpLink(text, id, graphic) {
    var link;

    link = "<li>";
    link += "<a href='#" + id + "' title='navigate to " + text + "' class='content-nav__link--" + id + "'>";
    if (graphic) {
      link += "<i aria-hidden='true' class='graphic--" + graphic + "'></i>"
    }
    link += text;
    link += "</a></li>";

    return link;
  }

  /*
    addJumpLink() creates a jumplink target and prepends it do the elem passed in with a
    specified id.
  */
  addJumpLinkTarget($elem, id) {
    var jumplink = "<a id='" + id + "' name='" + id + "' class='" + this.jumpLinkTargetClass + "'></a>";

    // The link needs to be outside the header. Was causing layout issues.
    if ($elem.parents('.events-calendar').length > 0) {
      $(jumplink).insertBefore($elem.parents('.events-calendar__header'));
    }
    else {
      $(jumplink).insertBefore($elem);
    }
  }

  /*
    setActiveItem() takes a string as an argument that reprsents the id of the
    element that should be active.
  */
  setActiveItem(id) {
    // first remove active class from all.
    $.each(this.$contentNavLinks, (index, elem) => {
      var $elem = $(elem);

      if ($elem.hasClass(id)) {
        $elem.addClass('active');
      }
      else {
        $elem.removeClass('active');
      }
    })
  }

  open() {
    if (this.isAnim) return;

    this.$nav.addClass('open');
    accessibility.toggleTabbing(this.$nav, 'open', this.$closeBtn);

    if (breakpoints.current === 'xlarge' && !this.winIsLarge()) {
      this.isAnim = true;

      window.TweenLite.to([this.$body, this.$mainNav], .2, {
        left: this.$nav.width(),
        onComplete: () => {
          this.isAnim = false;
          this.$closeBtn.off('click.navigatorClose').on('click.navigatorClose', (e) => {
            this.close();
          });
          this.bindSwipeToClose();
        }
      });
    }
    else {
      this.$closeBtn.off('click.navigatorClose').on('click.navigatorClose', (e) => {
        this.close();
      });
      this.bindSwipeToClose();
    }
  }

  close() {
    if (this.isAnim) return;

    this.$nav.removeClass('open');
    accessibility.toggleTabbing(this.$nav, 'open', this.$closeBtn);

    if (breakpoints.current === 'xlarge' && !this.winIsLarge()) {
      this.isAnim = true;

      window.TweenLite.to([this.$body, this.$mainNav], .2, {
        left: 0,
        onComplete: () => {
          this.isAnim = false;
          this.$closeBtn.off('click.navigatorClose');
          this.unbindSwipeToClose();
        }
      });
    }
    else {
      this.$closeBtn.off('click.navigatorClose');
      this.unbindSwipeToClose();
    }
  }

  winIsLarge() {
    return window.innerWidth > 1280 + (this.$nav.width() * 2);
  }

  bindSwipeToClose() {
    this.hammer = new Hammer(this.$body[0]);
    this.hammer.on('swipeleft', (e) => {
      this.close();
    });

    if (breakpoints.current === 'xlarge' && !this.winIsLarge()) {
      $(window).on('scroll.Navigator', (e) => this.handleHorizScroll(e));
    }
  }

  unbindSwipeToClose() {
    if (this.hammer) {
      this.hammer.off('swipeleft');
    }
    $(window).off('scroll.Navigator');
  }

  handleHorizScroll(e) {

    if ($(window).scrollLeft() > 5) {
      this.close();
    }
  }
}

module.exports = ContentNav;
